import React, {useEffect, useState} from "react";
import API from "../../../apiService";
import Alert, {confirmedAlert} from "../../component/Alert";
import Table from "../../component/Table";
import ClinicTreatmentModal from "./ClinicTreatmentModal";

export default function ClinicTreatment() {

    const [modalShow, setModalShow] = useState(false)
    const [search, setSearch] = useState('')
    const [data, setData] = useState([])
    const [editedData, setEditedData] = useState(null)
    const [refClinics, setRefClinics] = useState([])

    useEffect(() => {
        loadData()
        loadClinics()
    }, [])

    useEffect(() => {
        if (editedData) {
            setModalShow(true)
        }
    }, [editedData])

    const loadData = async () => {
        let response = await API.get("/management/clinic-treatment/read")
        if (response.code === 200) {
            setData(response.data)
        }
    }

    const loadClinics = async () => {
        let response = await API.get("/management/clinics/read")
        console.log(response)
        if (response.code === 200) {
            setRefClinics(response.data.map(v => ({value: v.id, label: v.name})))
        }
    }

    const deleteData = id => confirmedAlert('Konfirmasi', 'Hapus data ini?', async () => {
        let response = await API.delete(`/management/clinic-treatment/delete/${id}`)
        if (response.code === 200) {
            Alert("success", "Data master berhasil dihapus")
            loadData()
        }
    })

    const create_button = (datas) => {
        return (
            <div>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => setEditedData({
                        clinic: {value: datas.clinic_id, label: datas.clinic.name},
                        treatments: datas.treatments.map(v => ({value: v.id, label: v.name}))
                    })}
                >
                    Edit
                </button>
                <button
                    className={`btn btn-outline-danger btn-sm`}
                    onClick={() => deleteData(datas.clinic_id)}
                >
                    Delete
                </button>
            </div>
        );
    }

    return (
        <div className="mt-5 ml-4 mr-4">
            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-sm-4">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary  align-items-right"
                                        data-toggle="collapse"
                                        data-target="#collapsePreview"
                                        aria-expanded="false"
                                        aria-controls="collapsePreview"
                                        onClick={() => setModalShow(true)}
                                    >
                                    <span className="btn-inner--icon">
                                        <i className="ni ni-fat-add"></i>
                                    </span>
                                        <span className="btn-inner--text"> Add</span>
                                    </button>
                                </div>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4">
                                    <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        name="search"
                                        id="search"
                                        placeholder="cari"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="border-0" />
                        <Table
                            headers={[
                                "No",
                                "Klinik",
                                "Tindakan",
                                "Aksi",
                            ]}
                            data={data}
                            columnMapper={(datas, key) => [
                                datas.clinic.name,
                                (<div style={{width: '100%', wordWrap: 'break-word', whiteSpace: 'normal'}}>
                                    {datas.treatments.map(v => v.name).join(', ')}
                                </div>),
                                create_button(datas),
                            ]}
                            pagination={true}
                        />
                    </div>
                </div>
            </div>
            <ClinicTreatmentModal
                show={modalShow}
                refclinics={refClinics}
                onHide={() => {
                    setEditedData(null)
                    setModalShow(false)
                }}
                reloaddata={() => {
                    loadData()
                }}
                editeddata={editedData}
            />
        </div>
    )
}